import { authHeader } from '../authservice/auth-header';
import axios from 'axios';
import { activeSolutionKeyForUser } from '@/suite/solutions';

export const productService = {
    createProduct,
    updateProduct,
    listProducts,
    listInsumos,
    updateAddInsumo,
    updateModifyInsumo,
    updateRemoveInsumo,
    transferStock,
    createRetailPurchase,
    listRetailPurchases,
    payRetailPurchase,
    listTags,
    updateProductStatus,
    importProducts,
    downloadStockLabels,
};

function handleResponse(response) {
    return new Promise(function(resolve,reject){
        if (response.status === 401) {
            reject(response)
        }else{
            resolve(response.data)
            /*
            if(response.data.valid){
                resolve(response.data)
            }else{
                reject(response.data)
            }
            */
        }
    })
}

function createProduct(bodyCreate) {
    const solutionKey = bodyCreate.solutionKey || currentSolutionKey();
    return new Promise(function(resolve){
        axios.post(`${process.env.VUE_APP_API}/api/item`, {...bodyCreate, solutionKey},{
            headers: authHeader()
        })
        .then(handleResponse)
        .then(data => {
            resolve(data)
        })
    })
}

function updateProduct(idProduct, bodyUpdate) {
    const solutionKey = bodyUpdate.solutionKey || currentSolutionKey();
    return new Promise(function(resolve){
        axios.put(`${process.env.VUE_APP_API}/api/item/${idProduct}`, {...bodyUpdate, solutionKey},{
            headers: authHeader()
        })
        .then(handleResponse)
        .then(data => {
            resolve(data)
        })
    })
}

function listProducts(solutionKeyOverride = null, options = {}) {
    const query = new URLSearchParams({
        solutionKey: solutionKeyOverride || currentSolutionKey(),
        ...(options.includeInactive ? {includeInactive: "true"} : {}),
        ...(options.idCompany ? {idCompany: options.idCompany} : {})
    }).toString();
    return new Promise(function(resolve){
        axios.get(`${process.env.VUE_APP_API}/api/item?${query}`,{
            headers: authHeader()
        })
        .then(handleResponse)
        .then(data => {
            resolve(data.items)
        })
    })
}

function updateProductStatus(idProduct, productStatus) {
    return new Promise(function(resolve, reject){
        axios.put(`${process.env.VUE_APP_API}/api/item/${idProduct}/visibility`, {productStatus},{
            headers: authHeader()
        })
        .then(handleResponse)
        .then(data => {
            resolve(data)
        })
        .catch(error => {
            reject(error && error.response && error.response.data ? error.response.data : error)
        })
    })
}

function importProducts(rows, solutionKeyOverride = null, options = {}) {
    const solutionKey = solutionKeyOverride || currentSolutionKey();
    return new Promise(function(resolve, reject){
        axios.post(`${process.env.VUE_APP_API}/api/item/import`, {solutionKey, rows, idCompany: options.idCompany || null},{
            headers: authHeader()
        })
        .then(handleResponse)
        .then(data => {
            resolve(data)
        })
        .catch(error => {
            reject(error && error.response && error.response.data ? error.response.data : error)
        })
    })
}

function filenameFromDisposition(disposition, fallback) {
    const header = String(disposition || "");
    const utf8Match = header.match(/filename\*=UTF-8''([^;]+)/i);
    if (utf8Match && utf8Match[1]) {
        return decodeURIComponent(utf8Match[1].replace(/"/g, ""));
    }

    const match = header.match(/filename="?([^"]+)"?/i);
    return match && match[1] ? match[1] : fallback;
}

function downloadStockLabels(options = {}) {
    const solutionKey = options.solutionKeyOverride || currentSolutionKey();
    const codeType = options.codeType === "qr" ? "qr" : "barcode";
    const query = new URLSearchParams({
        solutionKey,
        codeType,
        ...(options.idCompany ? {idCompany: options.idCompany} : {}),
        ...(options.status ? {status: options.status} : {}),
        ...(options.search ? {search: options.search} : {})
    }).toString();

    return new Promise(function(resolve, reject){
        axios.get(`${process.env.VUE_APP_API}/api/item/stock-labels?${query}`,{
            headers: authHeader(),
            responseType: "blob"
        })
        .then(response => {
            resolve({
                blob: response.data,
                filename: filenameFromDisposition(
                    response.headers["content-disposition"],
                    `stock-${solutionKey}-${codeType}.pdf`
                )
            })
        })
        .catch(error => {
            reject(error && error.response && error.response.data ? error.response.data : error)
        })
    })
}

function listTags(solutionKeyOverride = null) {
    const query = new URLSearchParams({solutionKey: solutionKeyOverride || currentSolutionKey()}).toString();
    return new Promise(function(resolve){
        axios.get(`${process.env.VUE_APP_API}/api/item/tags?${query}`,{
            headers: authHeader()
        })
        .then(handleResponse)
        .then(data => {
            resolve(data.items || [])
        })
    })
}

function transferStock(bodyTransfer) {
    const solutionKey = bodyTransfer.solutionKey || currentSolutionKey();
    return new Promise(function(resolve, reject){
        axios.post(`${process.env.VUE_APP_API}/api/item/transfer`, {...bodyTransfer, solutionKey},{
            headers: authHeader()
        })
        .then(handleResponse)
        .then(data => {
            resolve(data)
        })
        .catch(error => {
            reject(error && error.response && error.response.data ? error.response.data : error)
        })
    })
}

function createRetailPurchase(bodyPurchase) {
    const solutionKey = bodyPurchase.solutionKey || "tooretail";
    return new Promise(function(resolve, reject){
        axios.post(`${process.env.VUE_APP_API}/api/item/purchases`, {...bodyPurchase, solutionKey},{
            headers: authHeader()
        })
        .then(handleResponse)
        .then(data => {
            resolve(data)
        })
        .catch(error => {
            reject(error && error.response && error.response.data ? error.response.data : error)
        })
    })
}

function listRetailPurchases(params = {}) {
    const query = new URLSearchParams({
        solutionKey: "tooretail",
        ...(params.idCompany ? {idCompany: params.idCompany} : {}),
        ...(params.dateStart ? {dateStart: params.dateStart} : {}),
        ...(params.dateEnd ? {dateEnd: params.dateEnd} : {}),
        ...(params.payablesOnly ? {payablesOnly: "true"} : {})
    }).toString();
    return new Promise(function(resolve){
        axios.get(`${process.env.VUE_APP_API}/api/item/purchases?${query}`,{
            headers: authHeader()
        })
        .then(handleResponse)
        .then(data => {
            resolve(data.items || [])
        })
    })
}

function payRetailPurchase(idPurchase, bodyPayment) {
    return new Promise(function(resolve, reject){
        axios.post(`${process.env.VUE_APP_API}/api/item/purchases/${idPurchase}/payment`, bodyPayment,{
            headers: authHeader()
        })
        .then(handleResponse)
        .then(data => {
            resolve(data)
        })
        .catch(error => {
            reject(error && error.response && error.response.data ? error.response.data : error)
        })
    })
}

function currentSolutionKey() {
    try {
        return activeSolutionKeyForUser(JSON.parse(localStorage.getItem("user") || "{}"));
    } catch (error) {
        return localStorage.getItem("activeSolutionKey") || "tootable";
    }
}

function listInsumos() {
    return new Promise(function(resolve){
        axios.get(`${process.env.VUE_APP_API}/api/ingredient`,{
            headers: authHeader()
        })
        .then(handleResponse)
        .then(data => {
            resolve(data.items)
        })
    })
}

function updateAddInsumo(idProduct, bodyUpdate) {
    return new Promise(function(resolve){
        axios.put(`${process.env.VUE_APP_API}/api/item/${idProduct}/ingredient/add`, bodyUpdate,{
            headers: authHeader()
        })
        .then(handleResponse)
        .then(data => {
            resolve(data)
        })
    })
}

function updateModifyInsumo(idProduct, bodyUpdate) {
    return new Promise(function(resolve){
        axios.put(`${process.env.VUE_APP_API}/api/item/${idProduct}/ingredient/modify`, bodyUpdate,{
            headers: authHeader()
        })
        .then(handleResponse)
        .then(data => {
            resolve(data)
        })
    })
}

function updateRemoveInsumo(idProduct, bodyUpdate) {
    return new Promise(function(resolve){
        axios.put(`${process.env.VUE_APP_API}/api/item/${idProduct}/ingredient/remove`, bodyUpdate,{
            headers: authHeader()
        })
        .then(handleResponse)
        .then(data => {
            resolve(data)
        })
    })
}
